import { render, staticRenderFns } from "./docRelational.vue?vue&type=template&id=007121dd&scoped=true"
import script from "./docRelational.vue?vue&type=script&lang=js"
export * from "./docRelational.vue?vue&type=script&lang=js"
import style0 from "./docRelational.vue?vue&type=style&index=0&id=007121dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007121dd",
  null
  
)

export default component.exports